import { Button } from "@jhool-io/fe-components";

interface CommunicationNotesCellProps {
    notesCount: number;
    canAddNote: boolean;
    onClick(): void;
}

export default function CommunicationNotesCell({
    notesCount,
    canAddNote,
    onClick,
}: CommunicationNotesCellProps) {
    if (notesCount === 0 && !canAddNote) {
        return <span className="text-textSec">No notes</span>;
    }

    return (
        <Button
            variant="normal"
            size="auto"
            className="p-0 underline font-normal text-textLink"
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            {notesCount > 0
                ? `${notesCount} note${notesCount === 1 ? "" : "s"}`
                : "Add note"}
        </Button>
    );
}
